import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import axiosInstance from "../../Api/axiosInstance";



export const getAllCategory = async (params={})=>{
    let reponse = await  axiosInstance.get(API_ENDPOINTS.ProductCatalogue.GET_ALL_CATEGORIES,{
        // params:{...params}
        params:params
    });
    // console.log('reponse?.data-------------->',reponse?.data);
    return reponse?.data;
}  


export const getCategoryParentId = async ()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.ProductCatalogue.GET_CATEGORY_PARENTID);
    return  response?.data;
}

interface ReqBody {
        OrgunitId: number,
        CategoryType: string,
        CategoryName: string,
        CategoryDescription: string,
        CategoryDisplayOrder : number,
        CategoryParentId: number,
        CategoryMedia: string
}


export const getCategoryType = async()=>{
    let response = await axiosInstance.get(API_ENDPOINTS.ProductCatalogue.GET_CATEGORY_TYPE);
    return response?.data;
}



export const addProductCategory = async ({ReqBody}:{ReqBody:ReqBody})=>{
    const url = `${API_ENDPOINTS.ProductCatalogue.POST_ADD_CATEGOTY}`
    let response  = await axiosInstance.post(url,ReqBody);
}



interface ReqBodyUpdate{
    OrgunitId: number
    CategoryName: string,
    CategoryDescription: string,
    CategoryDisplayOrder: number,
    CategoryParentId: number
    CategoryType: string,
    CategoryMedia: string
}


export const updateProductCategory = async ({ReqBody,id}:{ ReqBody:ReqBodyUpdate, id:number|undefined})=>{
  
     const url =`${API_ENDPOINTS.ProductCatalogue.PUT_UPDATE_CATEGORY}/${id}`  
     let response = await axiosInstance.put(url,ReqBody);
     return response?.data;
}


export const deleteProdcutCategory = async(id:number)=>{
    let reponse = await axiosInstance.delete(`${API_ENDPOINTS.ProductCatalogue.DELETE_CATEGORY}/${id}`);
    return  reponse?.data;

}


/*********************************************** TAGE ***********************************************/

export const getAllTage = async (params = {})=>{
  
    let response  = await axiosInstance.get(API_ENDPOINTS.TAGES.GET_TAGE,{
        params:params
    });
    // console.log(response?.data);
    return response?.data;
}


interface ReqBody{
    tag_name: string 
}

export const addTages = async({ReqBody}:{ReqBody:ReqBody})=>{
    const Url = `${API_ENDPOINTS.TAGES.POST_ADD_TAGES}`
    let response = await axiosInstance.post(Url,ReqBody)
    // response?.data;
}




export const upDateTages = async({ReqBody,id}:{ReqBody:ReqBody,id:number})=>{
   
    const Url = `${API_ENDPOINTS.TAGES.PUT_UPDATE_TAGES}/${id}`
     let response = await axiosInstance.put(Url,ReqBody);
     return response?.data

}